import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'

/**
 * @param props
 * @param props.routeAndMatch
 * @return {boolean}
 */
const isArticleRouterSelectUtil = (props) => {
  const { routeAndMatch } = props

  return (
    routeAndMatch?.route?.path === ROUTE_PATH.ARTICLES_BY_CATEGORY_OR_SLUG &&
    !!routeAndMatch?.match?.params?.slug
  )
}

export default isArticleRouterSelectUtil
